import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from 'app/services';
import { HttpService } from 'app/services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private httpService: HttpService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const redirect = path => {
      //window.location.pathname = path.replace('/', '');
      return this.router.createUrlTree([path]);
    };

    //confirm user is logged in or redirect to login 
    const authCheck = (): Promise<boolean | UrlTree> => 
      this.authService.refreshToken().toPromise().then(() => 
        !this.authService.isLoggedIn() ?
          redirect('/login') :
          true
      ).catch(() => redirect('/login'));

    //confirm existing payment method or redirect to payment methods
    const paymentCheck = (): Promise<boolean | UrlTree> => 
      state.url == '/payment-method' || state.url == '/change-password'?
        new Promise(res => res(true)) :
        this.httpService.businessHasPaymentMethod().toPromise().then(res =>
          !res?.length ?
            redirect('/payment-method') :
            true
        ).catch(() => redirect('/payment-method'));

    //confirm user's role is allowed to view route or redirect
        const roleCheck = (): boolean | UrlTree => 
          this.authService.currentUser?.roles.indexOf('entadm') >= 0? true :
          this.authService.currentUser?.roles.indexOf('busadm') >= 0? true :
          this.authService.currentUser?.roles.indexOf('busfin') >= 0?
            state.url === '/payment-method' || state.url === '/invoices' || state.url === '/subscriptions'?
              true:
              redirect('/subscriptions') : 
              redirect('/error-403') ;

    //execute auth, payment, and role checks in that order
    return new Promise((resolve, reject) =>
      authCheck().then(authRes =>
        authRes === true ?
          paymentCheck().then(payRes =>
            payRes === true ?
              resolve(roleCheck()) :
              resolve(payRes)
          ) :
          resolve(authRes)
      )
    );
  }
}
